import { render, staticRenderFns } from "./DetectedPersonalities.vue?vue&type=template&id=59418b4f&scoped=true"
import script from "./DetectedPersonalities.vue?vue&type=script&lang=js"
export * from "./DetectedPersonalities.vue?vue&type=script&lang=js"
import style0 from "./DetectedPersonalities.vue?vue&type=style&index=0&id=59418b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59418b4f",
  null
  
)

export default component.exports